import classNames from "classnames/bind";
import style from "./ModalConfirm.module.css";
import InputText from "../../User/AddUser/FormRegister/InputText";
import { useEffect, useRef, useState } from "react";
import { Button, Col, HeaderModal, Input, Row, Toast } from "../../../../components";
import { configDefault } from "../../../../services/api/configDefault";


const cx = classNames.bind(style);
function ModalConfirm({ isShow, token, onClose }) {
    const [code, setCode] = useState('');
    const [submit, setSubmit] = useState(false);
    const [error, setError] = useState({
        status: false,
        mess: ""
    })
    const refModal = useRef(null);
    const handleChangeAuthCode = (data) => {
        setCode(data)
    }

    const handleCancel = () => {
        onClose();
    }
    const onCheckCode = (code) => {
        return code?.trim().length === 6;
    }
    const handleFocus = () => {
        setSubmit(false);
        setError({
            status: false,
            mess: ""
        })
    }
    const handleSubmit = async () => {
        setSubmit(true)
        if (onCheckCode(code)) {
            try {
                const dataSubmit = {
                    code: code,
                    token: token,
                }
                await configDefault.postVerifyUpdate(dataSubmit);
                onClose();
                setSubmit(false);
                Toast.open("Lưu cài đặt thành công", "success")
            } catch (e) {
                // // console.log(e);
                setError({
                    status: true,
                    mess: e.code || "Có lỗi sảy ra với mã đã nhập"
                })
            }
        } else {
            setError({
                status: true,
                mess: "Mã xác thực dài 6 ký tự"
            })
        }
    }

    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (e.target === refModal.current) {
                onClose();
            }
        };
        document.addEventListener("click", handleCloseOnClickOutSide);
        return () => {
            document.removeEventListener("click", handleCloseOnClickOutSide);
        };
        // eslint-disable-next-line
    }, []);
    return (
        <div className={cx('wrapper')} style={isShow ? { display: 'flex' } : { display: 'none' }} ref={refModal}>
            <div className={cx('container')}>
                <HeaderModal onClose={onClose} title={'Nhập mã xác thực'} />
                <div className={cx('form-code')}>
                    <div className={cx('form-input')}>
                        <label className={cx('label-input', submit && error.status && "error")} htmlFor="CODE">Mã xác thực *</label>
                        <input
                            className={cx('input-code', submit && error.status && "border-error", submit && error.status && 'error')}
                            name="CODE"
                            id="CODE"
                            onChange={(e) => handleChangeAuthCode(e.target.value)}
                            placeholder="Nhập mã xác thực"
                            maxLength={6}
                            value={code}
                            onMouseDown={handleFocus}
                        />
                    </div>
                    {error.status && <span className={cx("error-mess", "error")}>{error.mess}</span>}
                    <div className={cx('note-message')}>Chú ý: Mã đã được gửi về email của quản trị viên, mã có hiệu lực trong vòng 1 giờ.</div>
                    <div className={cx('foolter')}>
                        <Button onClick={handleCancel} title={"Hủy"} className={cx('btn', 'cancel')} />
                        <Button onClick={handleSubmit} title={"Xác nhận"} className={cx('btn')} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalConfirm;